import { render, staticRenderFns } from "./WorkspaceTopbar.vue?vue&type=template&id=106583e6&scoped=true&"
import script from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106583e6",
  null
  
)

export default component.exports